import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import BasicDropdownToggle from '../BasicDropdownToggle';
import { PopperDropdownContext } from './PopperDropdownContext';
const PopperDropdownToggle = (_param)=>{
    var { children } = _param, props = _object_without_properties(_param, [
        "children"
    ]);
    const { setToggleRef } = useContext(PopperDropdownContext);
    return /*#__PURE__*/ React.createElement(BasicDropdownToggle, _object_spread_props(_object_spread({}, props), {
        innerRef: setToggleRef
    }), children);
};
PopperDropdownToggle.displayName = 'PopperDropdownToggle';
export default PopperDropdownToggle;

//# sourceMappingURL=PopperDropdownToggle.js.map